<script setup lang="ts">
import {
  CollapsibleContent,
  CollapsibleRoot,
  CollapsibleTrigger,
} from "reka-ui"
import { availableFeatures } from "~/utils/features"

const { devState } = useDeveloperTools()
const {
  clearFeatureOverrides,
  featureOverrides,
  hasFeature,
  hasSessionFeature,
  setFeatureOverride,
} = useAuth()

const hasFeatureOverrides = computed(
  () => Object.keys(featureOverrides.value).length > 0,
)

function hideDevTools() {
  devState.value = {
    loading: false,
    empty: false,
    loadingDelay: 0,
    expanded: false,
    hidden: true,
  }
}
</script>
<template>
  
</template>
